var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.001,
    viewBox: "0 0 15 15.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9533",
    "data-name": "Group 9533",
    transform: "translate(-67.152 -1522.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3327",
    "data-name": "Path 3327",
    d: "M82.152,1530.029a7.5,7.5,0,0,1-15-.107,7.5,7.5,0,1,1,15,.107Zm-7.529,6.359a6.422,6.422,0,0,0,.079-12.843,6.422,6.422,0,1,0-.079,12.843Z",
    transform: "translate(0)",
    fill: "#cebb6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3328",
    "data-name": "Path 3328",
    d: "M105.956,1548.478a4.689,4.689,0,0,1-.426.615c-1.295,1.308-2.6,2.6-3.9,3.912a.661.661,0,0,1-1.093,0c-1.564-1.584-1.523-1.258-.1-2.693,1.031-1.038,2.078-2.059,3.1-3.109.429-.443.794-.456,1.205,0C105.123,1547.624,105.526,1548.028,105.956,1548.478Zm-5.341,2.924c.01.089.163.5.174.592.194-.034.615.131.733.018q1.471-1.415,2.885-2.89c.1-.107-.289-.85-.289-1.216Z",
    transform: "translate(-27.343 -20.707)",
    fill: "#cebb6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    "data-name": "Path 3329",
    d: "M93.742,1582c.213-.016.379-.078.5-.028a4.732,4.732,0,0,1,.645.386c-.16.221-.285.586-.486.634a13.9,13.9,0,0,1-1.8.219c.021-.553.028-1.106.068-1.657.029-.407.194-.826.666-.689.2.057.279.531.4.819A1.116,1.116,0,0,1,93.742,1582Z",
    transform: "translate(-21.6 -49.545)",
    fill: "#cebb6c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModification);
export default __webpack_public_path__ + "static/media/modification.2b2d9f6969b0e5bf5dd2df1ad0ea3045.svg";
export { ForwardRef as ReactComponent };